import { SchoolCodeEnum } from '@utils/constan'

export interface IDynamicObject {
  [key: string]: any
}

export interface IGenericObject<T> {
  [key: string]: T
}

export interface ILogLevels {
  verbose: number
  debug: number
  info: number
  error: number
  none: number
}

export interface ProfileEmail {
  email: string
  family_name: string
  given_name: string
  id: string
  locale: string
  name: string
  picture: string
  verified_email: boolean
}

export interface ProfileFB {
  email: string
  id: string
  name: string
  picture: {
    data: {
      height: number
      is_silhouette: boolean
      url: string
      width: number
    }
  }
}

export type ResponseBase<T = any, TStatus = boolean> = {
  code: number
} & (TStatus extends true
  ? {
      data: T

      status: true
    }
  : {
      status: false

      msg?: string | null
    })

export interface BillsResponse {
  code: number
  data: {
    pagination: { totalRows: number; totalPages: number }
    records: BillType[]
  }
}

export interface ItemBillResponse {
  code: number
  data: BillType[]
}
export interface BillHistoryResponse {
  code: number
  data: {
    bill_list: BillsHistory[]
    createdAt: string
    gmail: string
    id: string
    name: string
    type_account: string
    _id: string
  }
}

export interface BillsHistory {
  chi_tiet: string
  da_thu: string
  ma_sv: string
  noi_dung: string
  payment_type: string
  so_phieu_bao: string
  ten_truong: string
  time_payment: string
}

export interface responseResult {
  code: number
  data: { code: string }
  message: string
}

export interface SchoolOrg {
  schoolOrg: string
}

// Cấu hình miễn phí tiện ích cho giao dịch vãng lai dưới ngưỡng (trả kèm danh sách phiếu thu)
export interface UtilitySurchargeExemption {
  enabled: boolean
  threshold: number
}

export const DEFAULT_UTILITY_SURCHARGE_EXEMPTION: UtilitySurchargeExemption = {
  enabled: false,
  threshold: 100000,
}

export interface BillType {
  IDSV: string
  IDSchool: string
  chi_tiet: string
  createdAt: string
  hoc_ky: number
  id_nhom_ct: number
  is_cho_nhap_so_tien: boolean
  ma_sv: string
  ma_loai_thu: any
  noi_dung: string
  phai_thu: number
  so_tien_phu_thu_tien_ich?: number | string | null
  is_vang_lai?: boolean
  trang_thai: string | number
  so_phieu_bao: string
  status: string | number
  _id: string
  tt_sv: string
  ten_truong: string
  mien_giam: number
  tong_thu: number
  date_line: number
  kenh_thu: string
  ngay_tao: string
  ngay_thu: number
  hoc_ky_chu: string
  is_bat_buoc_thanh_toan: boolean
  is_bat_buoc_thanh_toan_het: boolean
  is_nhap_tien: boolean
  is_skip_select_bill?: boolean
  tien_toi_thieu: number
  time_pending?: number
  qrCode?: string
  paymentChannel?: string
  so_phieu_bao_group?: string
  so_thu_tu_thanh_toan_chung?: number | null
  nguon_thu_hp?: string
  transactionCode?: string
  amount?: number
  vietQRImage?: string
}
export interface ListBankVCBType {
  code: string
  name: string
  logo: string
}
export interface StudentInfor {
  AvatarSV: string
  Email: string
  HoTen: string
  IDSV: string
  IDTruong: string
  Khoa: string
  MaLop: string
  MaSV: string
  Nganh: string
  NienKhoa: string
  SoCMND: string
  Tel: string
  ThongTinSinhVien: string
  createdAt: string
  _id: string
}

export interface IPaymentMethod {
  _id: string
  status: number
  name: string
  ruleType: string
  amount?: number
  sign?: string
  priorityChoose?: string
  ruleConfig: {
    name: string
    percent: string
  }[]
}
export type TypeMethodPayment = {
  icon: string
  title: string
  description: string
  id: number | string
  sign?: boolean
  type?: string
  priorityChoose?: string
  child?: TypeMethodPayment[]
  img?: string
  status?: boolean
  paymentsTitle?: string
  payments?:
    | {
        id: number
        name: string
        code: string
        bin: string
        shortName: string
        logo: string
        transferSupported: number
        lookupSupported: number
        short_name: string
        support: number
        isTransfer: number
        swift_code: string
        icon?: string
        title?: string
      }[]
    | { icon: string; title: string; id: string }[]
}

export interface IPayment {
  icon: string
  title: string
  id: string
}

export interface IBankPaymentGateway {
  _id: string
  name: string
  status: number
}

export interface ITransactionHistory {
  _id: string
  ma_sv: string
  schoolCode: string
  orgCode: string
  orgName: string
  schoolName: string
  noi_dung: string
  tmnCode: string
  tmnHashSecret: string
  orderId: string
  paymentMethod: string
  bankCode: string
  createDate: number
  amount: number
  totalAmount: number
  so_phieu_bao: string
  status: number
  createdAt: string
  updatedAt: string
  bills: BillType[]
  qrCode: string
  paymentChannel: string
  transactionCode?: string
  vietQRImage?: string
}

export interface ITransactionHistoryResponse {
  code: 200
  data: ITransactionHistory[]
}

export interface IStudeninfor {
  AvatarSV: string
  Email: string
  HoTen: string
  IDSV: string
  IDTruong: string
  Khoa: string
  MaLop: string
  MaSV: string
  MaVAC: string
  Nganh: string
  NienKhoa: string
  SoCMND: string
  Tel: string
  createdAt: string
  updatedAt: string
  _id: string
  orgCode: string
  schoolCode: string
  redirect_success?: string
}
export interface IGroupDetail {
  _id: string
  orgName: string
  orgCode: string
  status: number
  address: string
  email: string
  phone: string
  startTime: number
  endTime: number
  logo: string
  bannerPath: string[]
  listSchool: IEdubillDetail[]
}
export interface IEdubillDetail {
  apiKey: string
  apiKey_edusoft: string
  createdAt: string
  email: string
  fax: string
  golive: true
  idSchool: string
  orgCode: string
  orgName: string
  phone: string
  schoolCode: string
  schoolName: string
  schoolUrl: string
  status: number
  comingSoon?: string
  updatedAt: string
  avatarUrl?: string
  address?: string
  _id: string
  isSearchCCCD: boolean
  isSearchMaSV: boolean
}

export interface IPaymentMethodResponse {
  code: 200
  data: {
    _id: string
    schoolCode: string
    paymentMethod: IPaymentMethod[]
    bankPaymentGateway: IBankPaymentGateway[]
    status: number
    createdAt: string
    message?: string
  }
}

export type SCHOOL_CODE = {
  CODE: SchoolCodeEnum.DHHV | SchoolCodeEnum.TNUT | undefined
}

export interface EmitTrasnSocketNotifyContext {
  orgCode: string
  schoolCode: string
  trasactionId: string
  success: boolean
}

export interface EmitTrasnSocketNotify {
  context?: EmitTrasnSocketNotifyContext
  orgCode?: string
  schoolCode?: string
  trasactionId?: string
  success?: boolean
}

export interface IResponeICB {
  transactionCode: string
  billIds: string[]
  amount: number
  vietQRImage: string
  accountNumber: string
  accountName: string
}

export interface IResponeVCB {
  transactionCode: string
  amount: number
  qrCodeBase64: string
  school: string
  token: string
}
export interface IResponeKLB {
  transactionCode: string
  amount: number
  accountName: string
  virtualAccount: string
  content: string
  qrLink: string
}

export interface IResponeAGRIBANK {
  transactionCode: string
  amount: number
  accountName: string
  virtualAccount: string
  content: string
  qrLink: string
}
export interface IResponePVCB {
  transactionCode: string
  amount: number
  school: string
  alias: string
  invoiceExpiryTime: string
  qrCodeText: string
}
